<div class="container">
    <div class="text">
        <div>
            {{text}}
        </div>
    </div>
    <div mat-dialog-actions class="btns">
        <button mat-button [mat-dialog-close]="false">Ok</button>
    </div>
</div>